import { useId, useState } from "react";
import styled from "styled-components";
import { BsChevronDown } from "react-icons/bs";

const FaqList = styled.div`
  display: flex;
  flex-direction: column;
`;

const FaqItem = styled.div`
  border-bottom: 1px solid #f1f1f1;

  &:last-child {
    border-bottom: none;
  }
`;

const FaqTrigger = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 0.25rem;
  border: none;
  background: #fff;
  text-align: left;
  font-weight: 600;
  font-size: 0.95rem;
  color: ${(p) => (p.$open ? "var(--color-primary)" : "#383838")};
  cursor: pointer;
  line-height: 1.45;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 0.2rem var(--color-secondary-soft);
    border-radius: 6px;
  }

  .faq-chevron {
    flex-shrink: 0;
    color: var(--color-secondary);
    transition: transform 0.2s ease;
    transform: ${(p) => (p.$open ? "rotate(180deg)" : "rotate(0deg)")};
  }
`;

const FaqAnswer = styled.div`
  padding: 0 0.25rem 1.25rem;
  color: #45464e;
  font-size: 0.9rem;
  line-height: 1.7;
`;

export default function InvestmentFaqList({ faqs = [] }) {
  const baseId = useId();
  const [openIndex, setOpenIndex] = useState(null);

  if (!faqs.length) return null;

  return (
    <FaqList role="list">
      {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        const panelId = `${baseId}-faq-${index}`;

        return (
          <FaqItem key={faq.question} role="listitem">
            <FaqTrigger
              type="button"
              $open={isOpen}
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => setOpenIndex(isOpen ? null : index)}
            >
              <span>{faq.question}</span>
              <BsChevronDown className="faq-chevron" size={18} aria-hidden />
            </FaqTrigger>
            {isOpen ? (
              <FaqAnswer id={panelId} role="region" aria-label={faq.question}>
                {faq.answer}
              </FaqAnswer>
            ) : null}
          </FaqItem>
        );
      })}
    </FaqList>
  );
}
